<template>
<div class="sample-form-message">
    <pt-sub-title title="订单信息"></pt-sub-title>
    <table :class="$style['sample-form-message-table']">
    <pt-form-list-item label="重采价格：" :required="true">
         <wt-input :class="$style['number-input-price']" v-model="form.resample_amount"  data-vv-as="重采价格" name="name" v-validate="'required'"><el-button slot="append">¥</el-button></wt-input>
    </pt-form-list-item>
    <pt-receiving-message v-if="sampleType!=='ADULT_STORAGE'" v-model="form.shippingAddress" :address="shipping_address" ref="receiving"></pt-receiving-message>
    <pt-form-list-item  @widthItem="widthItem" label="是否需要开票：" required>
        <wt-radio :radios="needInvoice" v-model="form.need_invoice"></wt-radio>
    </pt-form-list-item>
    </table>
    <pt-invoice-message v-if="form.needInvoice" v-model="form.invoice" :maxWidth="maxWidth" ref="invoice"></pt-invoice-message>
    <div class="button-div">
        <el-button type="primary" @click="createSampleRecollect" :loading="loading">创建</el-button>
    </div>
</div>
</template>
<script>
import ptReceivingMessage from 'cps/base/pt-receiving-message'
import ptInvoiceMessage from 'cps/base/pt-invoice-message'
import formMixins from 'mixins/form'
import { cashCount } from '@/utils/formUtils'
import { needInvoice } from '../../goods-order-options'
export default {
  mixins: [formMixins],
  components: {
    ptReceivingMessage,
    ptInvoiceMessage
  },
  props: {
    mallOrderId: {
      type: String,
      default: ''
    },
    sampleId: {
      type: String,
      default: ''
    },
    shippingAddress: {
      type: Object,
      default: function () {
        return {}
      }
    },
    recollectPrice: {
      type: Number,
      default: 0
    },
    placementDetails: {
      type: Object,
      default: function () {
        return {}
      }
    },
    sampleType: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      form: {
        need_invoice: 'false'
      },
      loading: false,
      shipping_address: this.shippingAddress,
      needInvoice: needInvoice,
      maxWidth: ''
    }
  },
  watch: {
    recollectPrice (val) {
      this.$set(this.form, 'resample_amount', (val && cashCount(val, true)))
    },
    shippingAddress: {
      handler: function (val) {
        this.shipping_address = val
      },
      deep: true
    },
    placementDetails: {
      handler: function (val) {
        this.form.need_invoice = (val.needInvoice || val.needInvoice === false) ? val.needInvoice.toString() : 'false'
        this.form.invoice = val.invoice || {}
      }
    },
    'form.need_invoice' (val) {
      this.$set(this.form, 'needInvoice', val === 'true')
    //   this.form.needInvoice = val === 'true'
    }
  },
  computed: {
    receiving () {
      return this.$refs.receiving
    },
    invoice () {
      return this.$refs.invoice
    }
  },
  methods: {
    widthItem (val) {
      this.maxWidth = val
    },
    createSampleRecollect () {
      this.validate('form').then(res => {
        if (this.sampleType === 'ADULT_STORAGE') {
          if (this.form.needInvoice) {
            this.invoice.validate().then(_ => {
              this.submit()
            })
          } else {
            this.submit()
          }
        } else {
          this.receiving.validate().then(response => {
            this.receiving.addressForm.address.validate().then(_ => {
              if (this.form.needInvoice) {
                this.invoice.validate().then(_ => {
                  this.submit()
                })
              } else {
                this.submit()
              }
            })
          })
        }
      })
    },
    submit () {
      this.form.resampleAmount = this.form.resample_amount && cashCount(this.form.resample_amount)
      this.form.mallOrderId = this.mallOrderId
      this.form.previousSampleId = this.sampleId
      this.loading = true
      this.$store.dispatch('creatSampleRecollect', this.form).then(res => {
        this.loading = false
        this.$message.success('创建订单成功')
        history.go(-1)
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '创建重采订单失败')
      })
    }
  }

}
</script>
<style module lang="less">
.number-input-price{
width: 200px
}
.sample-form-message-table{
    padding: 0 20px;
}
</style>
